// extracted by mini-css-extract-plugin
export default {"iconsWrp":"nav_card_iconsWrp__kEV7V"};